import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Location } from 'src/app/modules/location/models/location';

@Injectable()
export class CityFilterService {

    private selects: Subject<Location[]>;

    constructor() {
        this.selects = new Subject();
    }

    public setLocations(locations: Location[]): void {
        this.selects.next(locations);
    }

    public getSelectedLocation(): Observable<Location[]> {
        return this.selects.asObservable();
    }
}
